export default "__VITE_ASSET__BmcAprO0__"